<template>
    <div >

<div id="dogWalkingModal" class="modal fade" data-backdrop="static" show="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">

          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
          <h4>Dog Walking Preference</h4>
        </div>
        <div id="modalBody" class="modal-body">
            <DogWalking v-if="sitterServices.CityId!=null" :cityId="sitterServices.CityId"></DogWalking>  
          
        </div>
        
            
        
      </div>
    </div>

  </div>
     
    <div class="col-md-12 col-xs-12 wrapper-box">
            
     <div name="sitterServices">
        <div class="col-sm-12 remove-margins">
        <h3 style="margin-bottom:0px;margin-top: 10px;">Stay Duration Filter and Preference <span class="color-orange" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="New Optional Feature, only receive bookings that match your preferences">★</span> </h3>
        <p style="margin-bottom:0px;">Customize your preferred durations.</span></p>
                  <div class="wrapper-box  col-xs-12 col-sm-5 large-pad">
                  
                  <hr style="margin-top:0px;">
                    <label style="display:inline-block">Minimum stay duration <i class="fa fa-question-circle" style="color:orange" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="If you set this field to 3 days then you will not receive booking requests for 1 or 2 days"></i></label>
                    <div class="input-group">
                        <input type="number" pattern="\d*" class="form-control" v-model="sitterServices.MinimumStayDays" aria-describedby="sizing-addon2">
                        <span class="input-group-addon"><strong>Days</strong></span>
                    </div>
                    <br>
                    <label style="display:inline-block">Maximum stay duration <i class="fa fa-question-circle" style="color:orange" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="If you set this field to 7 days, then you will not receive any booking requests that spans more than 7 days"></i></label>
                    <div class="input-group">
                        <input type="number" pattern="\d*" class="form-control" v-model="sitterServices.MaximumStayDays" aria-describedby="sizing-addon2">
                        <span class="input-group-addon"><strong>Days</strong></span>
                    </div>
                    <br>
                    <label style="display:inline-block">Dont receive requests starting before <i class="fa fa-question-circle" style="color:orange" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="If you set this to 3 days, then you will not receive booking requests that starts tomorrow or in 2 days (0 means you can receive booking requests starting today)"></i></label>
                    <div class="input-group">
                        <input type="number" pattern="\d*" class="form-control" v-model="sitterServices.EarlierThanDays" aria-describedby="sizing-addon2">
                        <span class="input-group-addon"><strong>Days</strong></span>
                    </div>
                    <br>
                    <label style="display:inline-block">Dont receive requests starting after <i class="fa fa-question-circle" style="color:orange" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Setting this to 90 days means, you will not receive booking requests starting after 3 months"></i></label>
                    <div class="input-group">
                        <input type="number" pattern="\d*" class="form-control" v-model="sitterServices.LaterThanDays" aria-describedby="sizing-addon2">
                        <span class="input-group-addon"><strong>Days</strong></span>
                    </div>
                  </div>
                  
                </div>
                
            <h3 style="margin-bottom:0px;">Minimum one service should be added <span class="red-star" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to publish your profile">★</span></h3>
            <p style="margin-bottom:0px;">Boarding means you can host pets at your own home, Sitting means you visit pet owner home.</span></p>
                   <div class="wrapper-box  col-xs-12 col-sm-5 large-pad" v-for="service in sitterServices.SitterServicesDto" v-bind:class="{enabled: service.IsOffered}">
                   
                   <h3 v-bind:class="{'new-service': service.ServiceType==6}">{{service.Description}} <span v-if="service.ServiceType==6"> <i class="fa fa-paw"/> New <button class="btn btn-info btn-xs pull-right" style="font-size:smaller!important;" :for="service.Description" v-if="service.IsOffered" @click="dogWalkingShow()">Customize</button> </span></h3>
                    <div class="input-group">
                    <input type="number" pattern="\d*" :disabled="!service.IsOffered" v-on:change="somethingChanged()"  v-model="service.Price" class="form-control" placeholder="Enter your price"/>
                    <span class="input-group-addon"><strong class="h5">{{service.DescriptionPer}}</strong></span>
                    </div>
                    <div v-if="sitterServices.CityId==null && service.ServiceType==6">
                    
                            <p class="small text-danger" style="margin-top:8px;">Please add your location from About page</p>
                        </div>
                        <div v-else>
                    <li class="checkbox">
                   <label>
                   
                        
                    <input type="checkbox"  @click="checkCityId(service)" v-on:change="somethingChanged()" :id="service.Description" v-model="service.IsOffered" />
                        
                        
                        <label  class="small" style="padding-left:0px;" :for="service.Description" v-if="service.IsOffered" >Added to My Profile</label>
                        <label  class="small" style="padding-left:0px;" :for="service.Description" v-if="!service.IsOffered" >Add to My Profile</label>
                        
                        
                   </label>
                   
                    </li>
                    </div>
                    
                    

                   </div>
                
             


            </div>       
           
            
            <div class="col-lg-8 col-md-10 col-sm-12  col-xs-12" style="margin:0px; padding:0px;" >
             <button style="margin-top:20px;margin-left:0px;" class="btn large-pad btn-success btn-block btn-lg" @click="updateSitterServices()">{{saveChanges}}</button>
            </div>
            </div>
            </div>
            </div>
</template>


<script>

import Vue from 'vue'
import sitterApi from '../../../services/sitterApi'
import router from '../../../router'
import auth from '../../../auth'
import store from '../../../data/store'
import commonApi from '../../../services/commonApi'
import DogWalking from './DogWalking.vue'


export default {
    name: 'servicerates',
    data() {
        return {
            tempValue: '',
            saveChanges: "Save Changes",
            editing: false,
            
           
        }
        
    },
    components: {
        DogWalking
    },
    watch: {
          selectedLocations: function(){
          if (this.selectedLocations.length>0)
          {
              this.myPlaceholder = 'You can add more locations'
          } else {
              this.myPlaceholder = 'Add location or multiple locations'
          }
      }
    },
    methods: {
      
        checkCityId: function(service){
            console.log(service)
            if (this.sitterServices.CityId==null && service.ServiceType==6){
                 swal("Oopsy", "It seems you forgot to fill your Location details, we have taken you back to About Me page to complete them first.", "info")
                //  this.$router.push({path:'/sitter-profile-edit/about'})
                service.IsOffered = false
                 
            }
        },
        dogWalkingShow(){
              $('#dogWalkingModal').modal('toggle')
        },
          goDashboard(){
                var self = this
                
                 if (self.compUserRole=="Sitter" && localStorage.getItem('phoneConfirmed')=="False")
                {
                    swal({
                        title: "Mobile needs verifcation",
                        text: "In order to complete your profile the last step is to verify your Mobile phone, do you want to do it now?",
                        type: "success",
                        showCancelButton: true,
                        confirmButtonClass: 'btn-success',
                        confirmButtonText: "Yes take me there!",
                        cancelButtonText: "Later",
                        allowOutsideClick: false,
                        closeOnConfirm: true,
                        }, function(isConfirm){
                        if (isConfirm){
                        self.$router.push({path: '/account', force: true})
                        return;
                        } else {
                        router.push({ path: '/sitter-profile-edit/calendar'});
                        }
                    });
                } else {
                    router.push({ path: '/sitter-profile-edit/calendar'});
                }
                
            },
         updateSitterServices: function () {
            var self = this

            const index = this.sitterServices.SitterServicesDto.findIndex(t => t.IsOffered === true)
            if (index == null || index==-1) {
                swal("Something is missing", "Please add at least one service to your profile","info")
                return
            } 
            
            self.saveChanges = "Saving.."
            sitterApi.updateSitterServices().then(function (){
                self.saveChanges = "Saved"
                self.editing = false
                self.$parent.updateProfileStatus()
                if (self.profileReadyComp==false)
                    self.goDashboard()
               
               
                
            }).fail(function (){
                self.saveChanges = "Failed to Save"
                self.editing = false
            })
        },
        somethingChanged: function(){
            this.editing=true
            this.saveChanges = "Changes Pending Save"
        }
    
        
    },
    created: function () {
        var self = this

        if (!store.getters.authenticated && !localStorage.getItem('access_token')) {
            router.router.push({ path: '/login', query: { redirect: 'sitterprofile/servicerates' } })
        }
        if (!store.getters.SitterServices){
            sitterApi.getSitterServices()
        }
       
    },
    mounted(){
     


    },
    updated(){
        this.$ga.page(this.$router)

    },
    computed: {
        sitterServices: function(){
            return store.getters.SitterServices
        },
        compUserRole: function(){
            return store.getters.userRole
        },
        profileReadyComp: function(){
            return this.$parent.profileStatus.IsProfileReady
        }
      
    },
   

  

}

</script>


<style scoped>


.new-service{
    color:#78b5d2
    
}

.input-group-addon {
    font-size: 9px;
}

.enabled{
    background-color: aliceblue !important;
}


.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  
  margin: 0;
  padding: 0;
}


.modal-content {
  height: auto;
  min-height: 100%;
  border-radius: 5px;
}

.modal {
  text-align: center;
}

 .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }


@media (max-width: 767px) {
.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
    width: 90%;
  
  margin: 0;
  padding: 0;
}
}



</style>


// WEBPACK FOOTER //
// ServiceRates.vue?78be2c10